/**
 * Parse a microservice call response and returns the data value.
 *
 * @param response
 */
export async function resolveResponseData<T>(response: Response): Promise<T> {
    const parsedJson = await response.json();
    if (!response.ok) return Promise.reject(await parsedJson.error);
    return parsedJson.data;
}
